// extracted by mini-css-extract-plugin
module.exports = {"container":"TerpeneCard_container__U_cWE","image_wrapper":"TerpeneCard_image_wrapper__sXdB1","title":"TerpeneCard_title__d55M0"};